import React, { useState, useEffect } from "react";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { Checkbox } from "@progress/kendo-react-inputs";
import { useSelector } from "react-redux";
import {
  updateChartOptionsParams,
  getChartOptionsSelector,
} from "../Slices/ChartOptionsSlice";
import { useAppDispatch } from "../../Core/store.hooks";
import { Button } from "@progress/kendo-react-buttons";

const ChartOptions = () => {
  const [showFrequencies, setShowFrequencies] = useState<boolean>();
  const [showDurations, setShowDurations] = useState<boolean>();
  const [showNumberOfItems, setShowNumberOfItems] = useState<string>();

  const chartoptions = useSelector(getChartOptionsSelector);
  const dispatch = useAppDispatch();
  useEffect(() => {
    setShowFrequencies(chartoptions.showFrequencies);
    setShowDurations(chartoptions.showDurations);
    setShowNumberOfItems(chartoptions.showNumberOfItems);
  }, [chartoptions]);

  //  useEffect(() => {
  //      if (showDurations != chartoptions.showDurations || showFrequencies != chartoptions.showFrequencies || showNumberOfItems != chartoptions.showNumberOfItems) {
  //          console.log(chartoptions)
  //          chartOptionsParamsHandler();
  //      }
  //}, [showFrequencies, showDurations, showNumberOfItems]);

  const handleShowFrequenciesChange = (e: any): void => {
    setShowFrequencies(e.target.element.checked);
  };

  const handleShowDurationsChange = (e: any): void => {
    setShowDurations(e.target.element.checked);
  };

  const handleNumberOfItems = (e: DropDownListChangeEvent): void => {
    setShowNumberOfItems(e.target.value);
  };

  const chartOptionsParamsHandler = () => {
    const params: any = {};
    params.showFrequencies = showFrequencies;
    params.showDurations = showDurations;
    params.showNumberOfItems = showNumberOfItems;

    dispatch<any>(updateChartOptionsParams(params));
  };

  return (
    <>
      <div className="title">Alarm Charts</div>

      <Checkbox
        name="showFrequencies"
        checked={showFrequencies}
        onChange={handleShowFrequenciesChange}
        label="Show Frequencies"
      />
      <br />

      <Checkbox
        name="showDurations"
        checked={showDurations}
        onChange={handleShowDurationsChange}
        label="Show Durations"
      />
      <br />
      <br />
      <div className="title">Number of Items</div>
      <DropDownList
        data={["10", "20", "30", "40", "All"]}
        value={showNumberOfItems}
        onChange={handleNumberOfItems}
      />
      <div>
        <Button
          className="pp-filter-button"
          onClick={() => chartOptionsParamsHandler()}
        >
          UPDATE
        </Button>
      </div>
    </>
  );
};

export default ChartOptions;
